var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-button',{staticClass:"button-more",attrs:{"to":_vm.to,"backgroundColor":_vm.backgroundColor,"color":"#FFFFFF"}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t(_vm.title)))])])}
var staticRenderFns = []

export { render, staticRenderFns }